/**
 * Created with JetBrains WebStorm.
 * User: yujy
 * Date: 16-03-29
 * Time: 上午10:41
 * To change this template use File | Settings | File Templates.
 */

export default class fvcRenderLine {
    constructor(){

    }
    rend(canvas, rect ,obj) {
        if(obj==undefined){
            console.warn("渲染对象不能为空");
            return;
        }
        if(rect.height==0||rect.width==0){
            return
        }
        var config = obj.renderConfig;
        config.rotate = config.rotate ? config.rotate : 0;
        //计算渐变起始终止点
        var startPt = {
            x:0,
            y:0,
            r:0
        };
        var endPt = {
            x:0,
            y:0,
            r:0
        };
        this.fcGetStartEndPt(startPt, endPt, rect, config.rotate1*FC_PI/180);

        var len = Math.sqrt((startPt.x - endPt.x) * (startPt.x - endPt.x)
                    + (startPt.y - endPt.y) * (startPt.y - endPt.y));
        var beginColor = config.color[0].colorRgb();
        var endColor = 'RGBA(255, 255, 255, 0)';
        if(config.color.length > 1){
          endColor = config.color[1].colorRgb();
        }
        // var endColor = config.color[1].colorRgb();
        
        var grd = canvas.createLinearGradient(startPt.x, startPt.y, endPt.x, endPt.y);
        if(!config.spot || config.spot.length == 0) {
                //添加返回颜色值为undefined 导致页面图元绘制不出bug 具体为啥返回undefined有待排查
                if(beginColor[0] == undefined){
                    grd.addColorStop(0, "RGBA(" + 0 + "," + 0 + "," + 0 + "," + 1 / 255 + ")");
                }else{
                    grd.addColorStop(0, "RGBA(" + beginColor[0] + "," + beginColor[1] + "," + beginColor[2] + "," + config.transparent[0] / 255 + ")");
                }
        }
        for(var i = 0; i < config.cycletimes; i++){
            this.fcAddColorStop(grd,config,i,beginColor,endColor,len);
        }
        canvas.fillStyle = grd;
        canvas.imageSmoothingEnabled = true;
        if(obj.round){
            this.roundRect(canvas,rect.left,rect.top,rect.width,rect.height,this.changeGrond(obj,rect),1,obj,rect);
        }else{
            canvas.fillRect(rect.left,rect.top,rect.width,rect.height); 
        }
        
        //canvas.stroke();
    }
    roundRect(canvas,x, y, w, h, r,flag,obj,rect) {
        //圆半径不能为负数
        if(parseFloat(r)<0){
            r = 0.1;
        }
        canvas.beginPath();
        if(obj.round[0]>obj.round[1]){
            //纵向
            if(obj.round[0]-obj.round[1]>15){
                r = this.changeGrond1(obj,rect);
                h = parseFloat(h)-r;
                y = parseFloat(y)+r/2;
                canvas.moveTo(parseFloat(x), parseFloat(y));
                canvas.bezierCurveTo(parseFloat(x),parseFloat(y)-r, parseFloat(x)+parseFloat(w), parseFloat(y)-r,parseFloat(x)+parseFloat(w),parseFloat(y));
                canvas.lineTo(parseFloat(x)+parseFloat(w),parseFloat(y)+parseFloat(h));
                canvas.bezierCurveTo(parseFloat(x)+parseFloat(w),parseFloat(y)+parseFloat(h)+r, parseFloat(x), parseFloat(y)+parseFloat(h)+r,parseFloat(x),parseFloat(y)+parseFloat(h));
                canvas.closePath();
            }else{
                canvas.moveTo(parseFloat(x)+parseFloat(r), parseFloat(y));
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(r));//右上
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(r));//右下
                canvas.arcTo(parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y), parseFloat(r));//左上
                canvas.arcTo(parseFloat(x), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(r));//左下
                canvas.closePath();
            }
        }else{
            //横向
            if(obj.round[1]-obj.round[0]>15){
                r = this.changeGrond1(obj,rect);
                w = parseFloat(w)-r;
                x = parseFloat(x)+r/2;
                canvas.moveTo(parseFloat(x), parseFloat(y));
                canvas.bezierCurveTo(parseFloat(x)-r,parseFloat(y),parseFloat(x)-r,parseFloat(y)+parseFloat(h),parseFloat(x),parseFloat(y)+parseFloat(h));
                canvas.lineTo(parseFloat(x)+parseFloat(w),parseFloat(y)+parseFloat(h));
                canvas.bezierCurveTo(parseFloat(x)+parseFloat(w)+r,parseFloat(y)+parseFloat(h),parseFloat(x)+parseFloat(w)+r,parseFloat(y),parseFloat(x)+parseFloat(w),parseFloat(y));
                canvas.closePath()
            }else{
                canvas.moveTo(parseFloat(x)+parseFloat(r), parseFloat(y));
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(r));//右上
                canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(r));//右下
                canvas.arcTo(parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y), parseFloat(r));//左上
                canvas.arcTo(parseFloat(x), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(r));//左下
                canvas.closePath();
            }
        }
        if(flag == 1){
            canvas.fill();
        }else{
            canvas.stroke();
        }
    }
    changeGrond(obj,rect){
        if(obj.round[0]*2 > this.width || obj.round[0]*2 > this.height){
            var widthHeight = rect.width > rect.height?rect.height:rect.width;
            obj.round[0] = widthHeight/2;
        }
        return obj.round[0];
    }
    changeGrond1(obj,rect){
        if(obj.round[1]*2 > this.width || obj.round[1]*2 > this.height){
            var widthHeight = rect.width > rect.height?rect.height:rect.width;
            obj.round[1] = widthHeight/2;
        }
        return obj.round[1];
    }
    //重复次数
    fcAddColorStop(grd, config, i, beginColor, endColor, len){
        if(config.spot && config.spot.length !=0){
            for(var j = 0; j < config.spot.length; j++){
                grd.addColorStop((i+config.spot[j])/config.cycletimes,"RGBA("+config.color[j].colorRgb()+","+config.transparent[j]/255+")");
            }
        }else{
            grd.addColorStop((i+config.symmetric)/config.cycletimes,"RGBA("+endColor[0]+","+endColor[1]+","+endColor[2]+","+config.transparent[1]/255+")");
            /*j = 1;
                while(j * 10 < (len * (1 - config.symmetric)/config.cycletimes)){//判断颜色渐变区间是否大于2个像素
                var k = j*10/len;
                var colorPar = k*config.cycletimes/(1-config.symmetric);
                var r = parseInt(endColor[0] + (beginColor[0] - endColor[0])* colorPar);
                var g = parseInt(endColor[1] + (beginColor[1] - endColor[1])* colorPar);
                var b = parseInt(endColor[2] + (beginColor[2] - endColor[2])* colorPar);
                grd.addColorStop(k + (i+config.symmetric)/config.cycletimes,"RGB("+r+","+g+","+b+")");//增加渲染区间
                j++;
                }*/
                if(config.symmetric < 1){
                  grd.addColorStop((i+1)/config.cycletimes,"RGBA("+beginColor[0]+","+beginColor[1]+","+beginColor[2]+","+config.transparent[0]/255+")");
                }
        }
    }

    fcGetStartEndPt(startPt, endPt, inputRect, inputAng){

        startPt.x = inputRect.left;
        startPt.y = inputRect.top;
        var centerPt = {
            x: parseInt(inputRect.left + inputRect.width / 2),
            y: parseInt(inputRect.top + inputRect.height / 2)
        }

        var tempAng1 = inputAng;
        while(tempAng1>(FC_PI/2) || tempAng1<0){
                if(tempAng1>FC_PI/2){
                    tempAng1 = Math.abs(tempAng1 - FC_PI);
                }else{
                    tempAng1 = tempAng1 + FC_PI;
                }
        }

        var tempAng2 = Math.atan(inputRect.height/inputRect.width);

        var tempAng3 = Math.abs(tempAng1 - tempAng2);

        var radius = parseInt(Math.sqrt(inputRect.width*inputRect.width + inputRect.height*inputRect.height)*Math.cos(tempAng3)/2);
        var colorChangeAng = inputAng;//计算渐变方向
        colorChangeAng = this.fcAdjustAng(colorChangeAng);//角度调整到 0到2*FC_PI

        startPt.x = -radius * Math.cos(colorChangeAng) + centerPt.x;
        startPt.y = -radius * Math.sin(colorChangeAng) + centerPt.y;

        endPt.x = radius * Math.cos(colorChangeAng) + centerPt.x;
        endPt.y = radius * Math.sin(colorChangeAng) + centerPt.y;
    }

    fcAdjustAng = function(ang){
        while(ang>2*FC_PI){
            ang = ang - 2*FC_PI;
        }

        while(ang<0){
            ang = ang + 2*FC_PI;
        }

        return ang;
    }
}



// WEBPACK FOOTER //
// ./src/js/render/fvRenderLine.js